export default function formLabel() {
    if(document.querySelector(".default-form")) {
        let labels = document.querySelectorAll(".input-disabled label");
        let inputs = document.querySelectorAll(".input-disabled input");

        inputs.forEach(input => {
            input.addEventListener("click", () => {
                labels.forEach(label => {
                    if(input.id == label.getAttribute("for")) {
                        label.classList.add("label-active");
                    }
                });
            });
        });

        if(document.querySelector(".input-disabled textarea")) {
            let textArea = document.querySelector(".input-disabled textarea");

            textArea.addEventListener("click", () => {
                labels.forEach(label => {
                    if(textArea.id == label.getAttribute("for")) {
                        label.classList.add("label-active");
                    }
                });
            });
        }
    }
}